import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'icon'];
  static values = { openByDefault: Boolean };

  connect() {
    this.storageKey = this.element.id;
    const storedState = localStorage.getItem(this.storageKey);

    if (storedState === 'open') {
      this.open();
    } else if (storedState === 'closed') {
      this.close();
    } else if (this.openByDefaultValue) {
      this.open();
    }
  }

  toggle() {
    const isOpen = !this.contentTarget.classList.contains('d-none');

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.contentTarget.classList.remove('d-none');
    this.iconTarget.classList.add('arrow-up');

    if (this.storageKey) {
      localStorage.setItem(this.storageKey, 'open');
    }
  }

  close() {
    this.contentTarget.classList.add('d-none');
    this.iconTarget.classList.remove('arrow-up');

    if (this.storageKey) {
      localStorage.setItem(this.storageKey, 'closed');
    }
  }
}
